const paymentFieldPlaceholders = {
  cardNumber: '1234 1234 1234 1234',
  expiryDate: 'MM/YY',
  CVC: '123'
};

export default paymentFieldPlaceholders;
